import { NgClass, NgSwitch, NgSwitchCase, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UrlModule } from '@spartacus/core';
import { CustomGenericLinkComponent } from '../custom-generic-link';

export enum MobileMenuItemType {
  BUTTON = 'button',
  LINK = 'link',
}

@Component({
  selector: 'sd-mobile-menu-item',
  templateUrl: './mobile-menu-item.component.html',
  styleUrls: ['./mobile-menu-item.component.scss'],
  imports: [NgSwitch, NgSwitchCase, NgTemplateOutlet, NgClass, CustomGenericLinkComponent, UrlModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MobileMenuItemComponent {
  @Input() variant: MobileMenuItemType = MobileMenuItemType.BUTTON;
  @Input() hideArrow = false;
  @Input() url: string;

  mobileMenuItemType: typeof MobileMenuItemType = MobileMenuItemType;
}
